import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=c5eca31c&scoped=true&"
import script from "./pager.vue?vue&type=script&lang=js&"
export * from "./pager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5eca31c",
  null
  
)

component.options.__file = "pager.vue"
export default component.exports